import React, { useEffect } from 'react'

import { signupConfig } from 'routes/Signup/signupConfig'
import { onEnter } from 'utils/accessibility'

import { useDiscountAppliedData } from './discountAppliedBarHooks'

import css from './DiscountAppliedBar.css'

type Props = {
  promoModalVisible: boolean
  isPromoBarHidden: boolean
  trackDiscountVisibility: (wizardStep: string) => void
  wizardStep: string
  isDiscountAppliedBarDismissed: boolean
  signupDismissDiscountAppliedBar: () => void
}

const DiscountAppliedBar = ({
  promoModalVisible,
  isPromoBarHidden,
  isDiscountAppliedBarDismissed,
  trackDiscountVisibility,
  wizardStep,
  signupDismissDiscountAppliedBar,
}: Props) => {
  const { isDiscountEnabled, discountTip } = useDiscountAppliedData()
  const isHidden = isDiscountAppliedBarDismissed || promoModalVisible || isPromoBarHidden
  const onClose = () => {
    signupDismissDiscountAppliedBar()
  }

  useEffect(() => {
    trackDiscountVisibility(wizardStep)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isHidden || !isDiscountEnabled) {
    return null
  }

  return (
    <div
      className={css.container}
      data-testid={isHidden ? 'DiscountAppliedBarContainerHidden' : 'DiscountAppliedBarContainer'}
    >
      <div className={css.successIcon} />
      <span className={css.discountText}>
        <span>{signupConfig.boxSizeStep.discountApplied}: </span>
        <strong>{discountTip}</strong>
      </span>
      <div
        className={css.closeIcon}
        role="button"
        tabIndex={0}
        onClick={onClose}
        onKeyDown={onEnter(onClose)}
      />
    </div>
  )
}

export { DiscountAppliedBar }
